import LayoutConfigTypes from '@/core/config/LayoutConfigTypes';

const config: LayoutConfigTypes = {
  themeName: 'Onit',
  themeVersion: '8.1.1',
  demo: 'SIC',
  main: {
    type: 'default',
    primaryColor: '#3661FF',
    logo: {
      dark: 'media/logos/ONIT_Logo_Color_On_Dark_bg.png',
      light: 'media/logos/ONIT_Logo_Color_On_Light_bg.png',
    },
  },
  illustrations: {
    set: 'sketchy-1',
  },
  loader: {
    logo: 'media/logos/ONIT_Mark_Color.svg',
    display: true,
    type: 'default',
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: 'font',
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: true,
    width: 'fluid',
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    theme: 'dark',
    fixed: true,
    menuIcon: 'font',
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: 'fixed',
  },
  footer: {
    width: 'fluid',
  },
};

export default config;
